import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider }    from "./hooks/useAuth";
import { usePageTracking } from "./hooks/useAnalytics";
import Navbar              from "./components/Navbar";
import OfflineBanner       from "./components/OfflineBanner";
import NotFoundPage        from "./pages/NotFoundPage";
import HomePage            from "./pages/HomePage";
import AwakenPage          from "./pages/AwakenPage";
import ProfilePage         from "./pages/ProfilePage";
import PublicProfilePage   from "./pages/PublicProfilePage";
import AuthPage            from "./pages/AuthPage";
import LorePage            from "./pages/LorePage";
import AboutPage           from "./pages/AboutPage";
import MerchPage           from "./pages/MerchPage";
import CoachPage           from "./pages/CoachPage";
import JournalPage         from "./pages/JournalPage";
import DuelPage            from "./pages/DuelPage";
import OniReformPage       from "./pages/OniReformPage";
import OniEvolvePage       from "./pages/OniEvolvePage";
import FFTTPage            from "./pages/FFTTPage";
import LeaderboardPage     from "./pages/LeaderboardPage";
import TeamBattlePage      from "./pages/TeamBattlePage";
import SocialPage          from "./pages/SocialPage";
import AdminPage           from "./pages/AdminPage";
import "./index.css";

function AppRoutes() {
  usePageTracking();
  return (
    <Routes>
      <Route path="/admin" element={<AdminPage />} />
      <Route path="*" element={
        <>
          <OfflineBanner />
          <Navbar />
          <Routes>
            <Route path="/"              element={<HomePage />} />
            <Route path="/awaken"        element={<AwakenPage />} />
            <Route path="/profile"       element={<ProfilePage />} />
            <Route path="/u/:uid"        element={<PublicProfilePage />} />
            <Route path="/auth"          element={<AuthPage />} />
            <Route path="/lore"          element={<LorePage />} />
            <Route path="/about"         element={<AboutPage />} />
            <Route path="/shop"          element={<Navigate to="/merch" replace/>} />
            <Route path="/merch"         element={<MerchPage />} />
            <Route path="/ranking"       element={<LeaderboardPage />} />
            {/* MON ONI */}
            <Route path="/journal"       element={<JournalPage />} />
            <Route path="/reform"        element={<OniReformPage />} />
            <Route path="/evolve"        element={<OniEvolvePage />} />
            <Route path="/coach"         element={<CoachPage />} />
            <Route path="/fftt"          element={<FFTTPage />} />
            <Route path="/onitalk"      element={<Navigate to="/journal" replace/>} />
            {/* COMBAT */}
            <Route path="/duel"          element={<DuelPage />} />
            <Route path="/team"          element={<TeamBattlePage />} />
            {/* SOCIAL */}
            <Route path="/social"         element={<SocialPage />} />
            {/* 404 */}
            <Route path="*"              element={<NotFoundPage />} />
          </Routes>
        </>
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
